import React from "react";
import { BrowserRouter } from "react-router-dom";
import LayoutDemo from "./layout";
import Layout2Demo from "./layout/MobileTest";
import Layout from "./layout/Layout";
import MainMenu from "./MainMenu";
import Help from "./help";
import Imprint from "./imprint";
import Contact from "./contact";
import Privacy from "./privacy";
import NotFound from "./NotFound";
import { Switch, Route } from "react-router-dom";
import Topics from "app/topics";
import Footer from "app/Footer";
import Homepage from "app/home";
import AuthPages from "app/auth";

const App = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Homepage} />
        <Route path="/layout" component={LayoutDemo} />
        <Route path="/help" component={Help} />
        <Route path="/imprint" component={Imprint} />
        <Route path="/contact" component={Contact} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/layout2" component={Layout2Demo} />
        <Route path="/topics" component={Topics} />
        <Route path="/(login|signup|reset|activate)" component={AuthPages} />
        <Route>
          <Layout
            navbar={<MainMenu />}
            main={<NotFound />}
            footer={<Footer />}
          />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js